import classNames from "classnames/bind";
import { classNames as primeClasses } from "primereact/utils";
import { Checkbox as PrimeCheckbox } from "primereact/checkbox";
import {
  Control,
  Controller,
  FieldValues,
  Path,
  RegisterOptions,
} from "react-hook-form";
import classes from "./Checkbox.module.scss";

type CheckboxProps<TData extends FieldValues> = {
  control: Control<TData>;
  name: Path<TData>;
  label?: string;
  disabled?: boolean;
  errorMessage?: string;
  rules?: RegisterOptions;
};

const Checkbox = <TData extends FieldValues>({
  control,
  disabled,
  label,
  name,
  errorMessage,
  rules,
}: CheckboxProps<TData>): React.ReactElement => {
  const cx = classNames.bind(classes);

  return (
    <div className={cx(classes.checkboxContainer, { disabled: disabled })}>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => (
          <PrimeCheckbox
            inputId={field.name}
            disabled={disabled}
            onChange={(e) => field.onChange(e.checked)}
            checked={field.value}
            className={primeClasses({ "p-invalid": errorMessage })}
          />
        )}
      />

      {label ? (
        <label
          htmlFor={name}
          className={primeClasses({
            "p-error": errorMessage,
          })}
        >
          {label}
        </label>
      ) : null}
    </div>
  );
};

export { Checkbox };
